// mutation常量
export const SET_LOGIN = 'SET_LOGIN' // 登陆

export const SET_LOGOUT = 'SET_LOGOUT' // 登出

export const SET_REFRESHTOKEN = 'SET_REFRESHTOKEN'

export const SET_TOKEN = 'SET_TOKEN'